export default __webpack_public_path__ + "static/media/logo-25.2bb95441.png";